<template>
  
</template>

<script>
import jwtToken from "../../helpers/jwt-token";
import {mapActions} from "vuex";
import VueNotifications from 'vue-notifications';

export default {
    name: 'Logout',
    data: ()=> ({
        user:{
            username: "",
            password: "",
            remember: false,
        }
    }),
    mounted(){
      this.$store.dispatch('unsetAuthUser')
      .then(() => {
        jwtToken.removeToken();
        this.$router.push({name: 'login'});
      });

    },
    methods:{
       

    }
}
</script>
<style scoped>
</style>
